import {
  ListItemText
} from "@mui/material";
import React from "react";
import { StyledDatosEmpresa } from "../../../../../styled/Empresa";


const DatosEmpresaContractual = ({ data }) => {

  return (
    <StyledDatosEmpresa.List >
      <StyledDatosEmpresa.ListItem key="polizaDigital" >
        <StyledDatosEmpresa.Label>Póliza Digital</StyledDatosEmpresa.Label>
        <ListItemText
          secondary={
            data?.polizaDigital ? data.polizaDigital : "Sin Información"
          }
        />
      </StyledDatosEmpresa.ListItem>
      <StyledDatosEmpresa.ListItem key="vigenciaDesde" >
        <StyledDatosEmpresa.Label>Vigencia</StyledDatosEmpresa.Label>
        <ListItemText
          secondary={
            data?.vigenciaDesde && data?.vigenciaHasta
              ? `${data?.vigenciaDesde} al ${data?.vigenciaHasta}`
              : "Sin Información"
          }
        />
      </StyledDatosEmpresa.ListItem>
      <StyledDatosEmpresa.ListItem key="tipoSolicitud" >
        <StyledDatosEmpresa.Label>Tipo de Solicitud</StyledDatosEmpresa.Label>
        <ListItemText
          secondary={
            data?.tipoSolicitud ? data.tipoSolicitud : "Sin Información"
          }
        />
      </StyledDatosEmpresa.ListItem>
      <StyledDatosEmpresa.ListItem key="contratoMixto" >
        <StyledDatosEmpresa.Label>Contrato Mixto</StyledDatosEmpresa.Label>
        <ListItemText secondary={data?.contratoMixto ? "Si" : "No"} />
      </StyledDatosEmpresa.ListItem>
      <StyledDatosEmpresa.ListItem key="nivelSeguridad" >
        <StyledDatosEmpresa.Label>Nivel de Seguridad</StyledDatosEmpresa.Label>
        <ListItemText
          secondary={
            data?.nivelSeguridad ? data.nivelSeguridad : "Sin Información"
          }
        />
      </StyledDatosEmpresa.ListItem>
      <StyledDatosEmpresa.ListItem key="cuss" >
        <StyledDatosEmpresa.Label>CUSS</StyledDatosEmpresa.Label>
        <ListItemText secondary={data?.cuss ? "Si" : "No"} />
      </StyledDatosEmpresa.ListItem>
      <StyledDatosEmpresa.ListItem key="suss" >
        <StyledDatosEmpresa.Label>SUSS</StyledDatosEmpresa.Label>
        <ListItemText secondary={data?.cuss ? "Si" : "No"} />
      </StyledDatosEmpresa.ListItem>
      <StyledDatosEmpresa.ListItem key="capitas" >
        <StyledDatosEmpresa.Label>Cápitas</StyledDatosEmpresa.Label>
        <ListItemText
          secondary={data?.capitas ? data.capitas : "Sin Información"}
        />
      </StyledDatosEmpresa.ListItem>
    </StyledDatosEmpresa.List>
  );
};

export default DatosEmpresaContractual;
